import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cdf9ec7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }


import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import PasswordTable from "./PasswordTable.vue";
import {PasswordFieldType} from "@/components/business/crud/interface/FieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

return (_ctx: any,_cache: any) => {
  const _component_a_input_password = _resolveComponent("a-input-password")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_input_password, {
      value: _unref(data)[_ctx.propName],
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
      placeholder: 
      _unref(data)[_ctx.propName + 'Set'] ? '修改' + _ctx.info.title : '请填写' + _ctx.info.title
    
    }, null, 8, ["value", "placeholder"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(PasswordTable, _mergeProps({ data: _unref(data) }, _ctx.$props), null, 16, ["data"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})